<template>
  <v-app id="app">
    <v-progress-linear
      class="app-loader"
      :active="appLoader.visibility"
      :color="appLoader.color"
      :indeterminate="true"
      height="4"
    ></v-progress-linear>

    <v-overlay
      :value="overlayLoader.visibility"
      class="overlay-loader"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <div v-if="!isAuthenticated || (isAuthenticated && noLayoutRequired)">
      <router-view></router-view>
    </div>

    <template v-if="isAuthenticated && !noLayoutRequired">
      <!-- Header -->
      <naj-header></naj-header>

      <naj-second-header></naj-second-header>

      <!-- Sidebar -->
      <!-- <naj-sidebar></naj-sidebar> -->

      <v-main class="naj-background-color">
        <!-- Content -->
        <div class="container-fluid naj-breadcrumb-container">
          <h1
            v-if="isPageHeadingVisible"
            class="naj-heading"
          >
            {{ currentPageTitle }}
          </h1>
          <naj-breadcrumb></naj-breadcrumb>
        </div>
        <div class="naj-content">
          <router-view></router-view>
        </div>
      </v-main>
      <naj-footer>
      </naj-footer>
    </template>

    <notifications
      position="top center"
      classes="app-toast"
    ></notifications>
  </v-app>
</template>

<script>
import axios from 'axios';
import { createNamespacedHelpers } from 'vuex';
import NajHeader from '@/modules/global/components/naj-header';
import NajFooter from '@/modules/global/components/naj-footer';
import { isAuthenticated, getAccessToken } from '@/helpers/utils';
import NajBreadcrumb from '@/modules/global/components/naj-breadcrumb';
import NajSecondHeader from './modules/global/components/naj-second-header.vue';

const { mapState, mapGetters } = createNamespacedHelpers('GlobalModule');
const { mapGetters: mapAuthGetters } = createNamespacedHelpers('AuthenticationModule');

export default {
  name: 'NajApp',
  components: {
    NajBreadcrumb,
    NajHeader,
    NajFooter,
    NajSecondHeader,
  },
  computed: {
    ...mapState({
      sideNavVisibility: state => state.sideNav.visible,
      appSettings: state => state.appSettings,
      appLoader: state => state.appLoader,
      overlayLoader: state => state.overlayLoader,
      collapsed: state => state.sideNav.collapsed,
    }),
    ...mapGetters(['currentPageTitle']),
    ...mapAuthGetters(['oidcIsAuthenticated']),
    isAuthenticated() {
      this.setAccessToken();
      return isAuthenticated() || this.oidcIsAuthenticated;
    },
    noTitle() {
      return Boolean(this.$route.meta.noTitle);
    },
    noLayoutRequired() {
      return Boolean(this.$route.meta.noLayoutRequired);
    },
    settingsClasses() {
      const settings = this.appSettings;
      return Object.keys(settings)
        .reduce(
          (classes, optionKey) => `${classes} ${settings[optionKey] || ''}`,
          ''
        );
    },
    isPageHeadingVisible() {
      return !this.noTitle && this.currentPageTitle; // old Condition
    },
  },
  mounted() {
  },
  methods: {
    setAccessToken() {
      if (!axios.defaults.headers.common.Authorization) { axios.defaults.headers.common.Authorization = getAccessToken(); }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/partials/_vars.scss";
.app-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 500;
}
.naj-breadcrumb-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 90px;
}
.naj-heading {
  font-size: 1.125rem;
  box-sizing: border-box;
  color: #323a46;
  font-weight: 600;
}
.naj-content {
  will-change: width;
  transition: width 0.4s;
  background-color: #ebeff2;
  position: relative;
  flex: 1;
}
.naj-background-color {
  background-color: #ebeff2;
}
.overlay-loader {
  z-index: 300 !important;
}

//toast
::v-deep .app-toast {
  font-size: 13px;
  padding: 10px;
  margin-top: 5px;
  border-radius: 5px;
  color: #fff;
  text-align: right;
}
::v-deep .v-main__wrap {
  padding: 4px 16px !important;
}
</style>
